import { Filter } from '@anytag/shared-molecules';
import { Template } from './Template';
import { useAnalyticsFilter } from './hooks';

export const AnalyticsFilter = () => {
  const { filter, setFilterForm } = useAnalyticsFilter();

  return (
    <Filter.Provider onSubmit={setFilterForm} values={filter}>
      <Template />
    </Filter.Provider>
  );
};

export { useAnalyticsFilter };
export * from './schemaTypes';
